import React, { useEffect, useState } from 'react';

export default function ContactForm() {
  const [cfToken, setCfToken] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  useEffect(() => {
    // Turnstile automatikusan kirendereli a containerbe
    const renderTurnstile = () => {
      if (window.turnstile && process.env.REACT_APP_TURNSTILE_SITE_KEY) {
        window.turnstile.render('#cf-turnstile', {
          sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
          callback: (token) => setCfToken(token),
          'error-callback': () => setCfToken(''),
          'expired-callback': () => setCfToken(''),
          'timeout-callback': () => setCfToken('')
        });
      } else {
        // Ha nincs Turnstile site key, engedélyezzük a form küldést
        setCfToken('demo-token');
      }
    };

    // Ha a script már betöltött, azonnal rendereljük
    if (window.turnstile) {
      renderTurnstile();
    } else {
      // Ha még nem, várjuk meg a betöltést
      window.addEventListener('load', renderTurnstile);
    }

    return () => {
      window.removeEventListener('load', renderTurnstile);
    };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formData = new FormData(e.currentTarget);
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.get('name'),
          email: formData.get('email'),
          message: formData.get('message'),
          cf_token: cfToken
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Hiba történt');
      }

      setSubmitStatus('success');
      e.target.reset();
      setCfToken('');
      
      // Reset Turnstile widget
      if (window.turnstile) {
        window.turnstile.reset('#cf-turnstile');
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Kapcsolat</h2>
      
      {submitStatus === 'success' && (
        <div className="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
          Üzenet sikeresen elküldve! Hamarosan felvesszük Önnel a kapcsolatot.
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
          Hiba történt az üzenet küldése során. Kérjük, próbálja újra.
        </div>
      )}

      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Név *
          </label>
          <input
            id="name"
            name="name"
            type="text"
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Teljes neve"
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            Email cím *
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="email@pelda.hu"
          />
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
            Üzenet *
          </label>
          <textarea
            id="message"
            name="message"
            required
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Írja ide üzenetét..."
          />
        </div>

        <div>
          <div id="cf-turnstile" style={{ margin: '12px 0' }}></div>
        </div>

        <button
          type="submit"
          disabled={!cfToken || isSubmitting}
          className={`w-full py-2 px-4 rounded-md font-medium transition-colors ${
            !cfToken || isSubmitting
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500'
          }`}
        >
          {isSubmitting ? 'Küldés...' : 'Üzenet küldése'}
        </button>
      </form>

      <p className="mt-4 text-xs text-gray-500 text-center">
        A kapcsolatfelvételhez szükséges a botvédelem teljesítése.
      </p>
    </div>
  );
}
